// extracted by mini-css-extract-plugin
module.exports = {"logoutButton":"profileandlogout_logoutButton__nWiQ0","logoutIconHover":"profileandlogout_logoutIconHover__8MKT1","logoutIcon":"profileandlogout_logoutIcon__6ily4"};